module.exports = "/images/our-blog-mobile.jpg";